var map = {
	"./BMG.svg": "30t7",
	"./BMGBusiness.svg": "FlYu",
	"./BMGEvents.svg": "b+Hy",
	"./BMGIntelligence.svg": "lJg8",
	"./BMGLifestyle.svg": "yWob",
	"./BMGNetworks.svg": "K8R3",
	"./_placeholder.svg": "VjLL",
	"./add.svg": "9+V+",
	"./arrow-down.svg": "vmK/",
	"./arrow-left.svg": "EwiG",
	"./arrow-right--double.svg": "14K8",
	"./arrow-right.svg": "87TX",
	"./arrow-up.svg": "UZdC",
	"./calendar.svg": "BDDi",
	"./check.svg": "FbqP",
	"./checkmark.svg": "cJCb",
	"./circle-hollow.svg": "RkPP",
	"./close.svg": "v5TL",
	"./download.svg": "rk/Z",
	"./email.svg": "wu45",
	"./expand-less.svg": "S5KF",
	"./expand-more.svg": "iXDO",
	"./facebook.svg": "WTGj",
	"./filter.svg": "I/tk",
	"./full-screen.svg": "5rp6",
	"./globe.svg": "sVn5",
	"./green-tick.svg": "qVmg",
	"./help.svg": "OOnu",
	"./info.svg": "btqN",
	"./instagram.svg": "yAB0",
	"./linkedin.svg": "i7Zg",
	"./listen.svg": "9s36",
	"./live.svg": "EWxW",
	"./location.svg": "dV2V",
	"./map-pin.svg": "d22m",
	"./medium.svg": "zFo2",
	"./menu.svg": "9H6L",
	"./navigate-next.svg": "xDgn",
	"./navigate-previous.svg": "s0CE",
	"./pause.svg": "q8Jc",
	"./person.svg": "Zppt",
	"./play-circle.svg": "CtiG",
	"./play-square.svg": "SIzs",
	"./play.svg": "duqV",
	"./quotationMarks.svg": "AB+s",
	"./remove.svg": "R93a",
	"./replay.svg": "xHYp",
	"./search.svg": "+zOZ",
	"./share.svg": "3X5L",
	"./tick.svg": "BDJG",
	"./twitter.svg": "OPph",
	"./visibility-off.svg": "Nl2G",
	"./visibility.svg": "OZ/M",
	"./youtube-red.svg": "GEfe",
	"./youtube.svg": "/jzQ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OMOf";